var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center"},_vm._l((_vm.dailyreport),function(item){return _c('div',{key:item.id,staticClass:"col-md-3 col-sm-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body text-center"},[_c('h3',[_c('b',[_vm._v(_vm._s(item.no))])]),_c('p',[_vm._v(_vm._s(item.description))])])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }